import { Component } from "@angular/core";
import { MdDialog } from "@angular/material";
import "../../../style/app.scss";
import { MyBackendService } from "../../services/my-backend";

@Component({
  selector: "my-app", // <my-app></my-app>
  template: require("./app.component.html"),
  styles: [require("./app.component.scss")]
})
export class AppComponent {
  constructor(private myBackendService: MyBackendService, private _dialog: MdDialog) {
  }

  setLoadClass() {
    setTimeout(() => {
      document.getElementsByClassName("login-theme")[0].className += " load";
    }, 0);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/app/app.component.ts